module.exports = __webpack_public_path__ + "img/_ABS9796.f586d1aa.jpg";